import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=66b29608"
import script from "./inbox.ts?vue&type=script&lang=js&external"
export * from "./inbox.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports